const MeetingStatuses = {
  Pending: 1,
  Confirmed: 2,
  Declined: 3,
  Cancelled: 4,
  Expired: 5,
}

export default MeetingStatuses
